import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CALL_LOG_EVENT_DIRECTION, CallLogEvent, UICallLogEvent } from '../../models/call-history.model';

@Component({
  selector: 'app-call-log-table',
  templateUrl: './call-log-table.component.html',
  styleUrls: ['./call-log-table.component.scss'],
})
export class CallLogTableComponent {
  @Input() callLog: CallLogEvent[] = [];
  @Input() loading: boolean;
  @Input() set loadingRows(v: number) {
    if (v) {
      this.skeletonRows = [];
      for (let i = 0; i < v; i++) {
        this.skeletonRows.push(i);
      }
    }
  }

  @Output() onClosingDetails: EventEmitter<void> = new EventEmitter();
  @Output() onOpeningDetails: EventEmitter<UICallLogEvent> = new EventEmitter();
  public skeletonRows: number[] = [0, 1, 2, 3, 4];
  public PhoneCallDirections = CALL_LOG_EVENT_DIRECTION;

  public isNumber(v: number | string): boolean {
    return typeof v === 'number';
  }

  public openDetails(record: UICallLogEvent): void {
    this.onOpeningDetails.emit(record);
  }
}
